export interface TabData {
  invoice: number;
  businessCards: string;
  buymeorder: number;
  nirlatgiftorders: number;
  priceoffers: number;
  post: number;
  favoritebusinesses: number;
  points: number;
  nirlatPromotions: number;
  [key: string]: number | string;
}
